import { useDispatch, useSelector } from "services/redux/rootReducer";
import { SubProductAction } from "features/product/types/actions.subproduct";
import Modal from "features/shared/components/modal";
import { DragDropContext, Droppable, DropResult } from "react-beautiful-dnd";
import TableRow from "../../row/tableRow";
import ModalHeader from "features/shared/components/modals/modalHeader";
import {
    MenuAndTableContainer,
    ModalContainer,
    RowsContainer,
    StyledTable,
    TableScrollWrapper,
} from "./tableContainerModal.styled";
import { BiPencil } from "react-icons/bi";
import TableMenu from "../../tableMenu";
import TableColumnGroups from "../../header/tableColumnGroups";
import HeaderRow from "../../header/headerRow";
import { ModalName } from "features/product/types/modals";
import SubmitButton from "features/shared/components/form/components/submitButton";

const TableContainerModal = () => {
    const { tables, shownTableId, readOnlyMode, locale, tempShownTable } =
        useSelector((state) => state.subProducts);
    const dispatch = useDispatch();

    const handleExitModal = () => {
        dispatch({
            type: SubProductAction.SET_SHOWN_TABLE_ID,
            id: "",
        });
        return;
    };

    const handleSubmitChanges = (applyTemp?: boolean) => {
        // i.e. take from temp state and reapply (works like undo)
        if (applyTemp)
            dispatch({
                type: SubProductAction.SET_TABLE_DATA,
                id: shownTableId,
                data: tempShownTable,
            });
        dispatch({
            type: SubProductAction.SET_TEMP_SHOWN_TABLE,
            table: {},
        });
        handleExitModal();
    };

    const handleCloseAndConfirm = () => {
        if (readOnlyMode) handleExitModal();
        if (
            window.confirm(
                "Are you sure you want to continue without saving? You will lose all changes made"
            )
        )
            handleSubmitChanges(true);
    };

    const handleToggleNameEditModal = () => {
        dispatch({
            type: SubProductAction.OPEN_MODAL,
            modal: {
                id: ModalName.NameEditModal,
            },
        });
    };

    // in case dropped outside the list
    const handleDragEnd = (result: DropResult) => {
        // dropped outside the list
        if (!result.destination) return;
        dispatch({
            type: SubProductAction.MOVE_AND_INSERT_SUBPRODUCT,
            oldIdx: result.source.index,
            newIdx: result.destination.index,
        });
    };

    const displayedSubproducts = tables[shownTableId]?.rows.map((id, idx) => {
        return <TableRow key={id} id={id} idx={idx} />;
    });

    return (
        <Modal id="productSubProduct" onCloseHandler={handleCloseAndConfirm}>
            <ModalContainer>
                <ModalHeader
                    onCloseHandler={handleCloseAndConfirm}
                    headingText={tables[shownTableId].name[locale]}
                >
                    {!readOnlyMode && (
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={handleToggleNameEditModal}
                        >
                            <BiPencil />
                        </span>
                    )}
                </ModalHeader>
                <MenuAndTableContainer readOnlyMode={readOnlyMode}>
                    <TableMenu />
                    <TableScrollWrapper>
                        <StyledTable onClick={(e) => e.stopPropagation()}>
                            <TableColumnGroups />
                            <DragDropContext onDragEnd={handleDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided) => (
                                        <RowsContainer
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                        >
                                            <HeaderRow />
                                            {displayedSubproducts}
                                            {provided.placeholder}
                                        </RowsContainer>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </StyledTable>
                    </TableScrollWrapper>
                    {!readOnlyMode && (
                        <SubmitButton
                            text="Save Table"
                            type="button"
                            onClick={() => handleSubmitChanges(false)}
                        />
                    )}
                </MenuAndTableContainer>
            </ModalContainer>
        </Modal>
    );
};

export default TableContainerModal;
